var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"href":_vm.link ? _vm.link : '#',"title":_vm.message}},[_c('b-icon',{attrs:{"icon":_vm.icon ? _vm.icon : 'exclamation-triangle-fill',"variant":_vm.variant ? _vm.variant : 'warning',"animation":_vm.animation ? _vm.animation : 'fade'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }